module.exports = "https://static.wmbcdn.com/uniweb/images/cae93d02883a82985f3dc39fecc02107.svg";